import { ReactNode } from "react";
import { IconProps } from "./_iconTypes";
import { iconSize } from "./_iconUtils";

type Props = IconProps & {
  /**
   * Define the content of the Icon.
   * @type ReactNode
   * @required
   */
  children: ReactNode;
};

export const Icon = (props: Props) => {
  const { id, children, className, fill, style, size, width, height, onClick} = props;
  return (
    <svg
      id={id}
      data-test-id={props["data-test-id"]}
      fill={fill}
      viewBox="0 0 32 32"
      className={className}
      style={{ display: "block", ...style }}
      width={width || iconSize(size).width}
      height={height || iconSize(size).height}
      aria-checked={props["aria-checked"]}
      aria-disabled={props["aria-disabled"]}
      onClick={onClick}
    >
      {children}
    </svg>
  );
}
